// Button variant types (styling)
export const AGENT = 'agent';
export const AGENT_GHOST = 'agent-ghost';
export const AGENT_SECONDARY = 'agent-secondary';
export const DESTRUCTIVE = 'destructive';
export const GHOST = 'ghost';
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';

export const BUTTON_TYPES = Object.freeze([
  AGENT,
  AGENT_GHOST,
  AGENT_SECONDARY,
  DESTRUCTIVE,
  GHOST,
  PRIMARY,
  SECONDARY,
  TERTIARY,
]);

// HTML button type attribute values
export const TYPE_BUTTON = 'button';
export const TYPE_RESET = 'reset';
export const TYPE_SUBMIT = 'submit';

export const HTML_BUTTON_TYPES = Object.freeze([TYPE_BUTTON, TYPE_RESET, TYPE_SUBMIT]);

export default {
  AGENT,
  AGENT_GHOST,
  AGENT_SECONDARY,
  BUTTON_TYPES,
  DESTRUCTIVE,
  GHOST,
  HTML_BUTTON_TYPES,
  PRIMARY,
  SECONDARY,
  TERTIARY,
  TYPE_BUTTON,
  TYPE_RESET,
  TYPE_SUBMIT,
};
